import * as React from 'react';
import { EventWrapper, Title } from './style'
import { FormDateField, FormTextField, FormSelectField, FormAddressField, DateNTimePicker } from '../Records/FormInput';
import { Box, Button, FormControl, FormLabel, Stack, styled, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useHorsesStore } from '../../../stores/horses';
import Upload from '../Records/Upload'
import { Controller } from 'react-hook-form'
import { PublicEvent } from './index'


type File = { fileUrl: string, name: string }
const App: React.FC<{ profileId?: string, isPublic?: boolean }> = (props) => {
    const methods = useForm();
    const { handleSubmit, control, setValue } = methods;
    const [file, setFile] = React.useState<File>();
    const store = useHorsesStore();
    const [openSuccessDialog, setOpenSuccessDialog] = React.useState(false);


    const onSubmit = async (data) => {
        console.log(data)
        const { _ID } = await store.addCalendar({
            ...data,
            event_type: 'Other',
            calendar_type: props.isPublic ? 'Public' : 'Private',
            regions: data['regions'] ? data['regions']['city'] + ' ' + data['regions']['region'] : null,
        })
        file && await store.addFile({
            name: file.name,
            url: file.fileUrl,
            profile_id: props.profileId,
            event_type: 'Other',
            calendar_id: String(_ID),

        })
        setOpenSuccessDialog(true);
    }

    const handleCloseSuccessDialog = () => {
        // 关闭弹窗
        setOpenSuccessDialog(false);
    }

    const completeHandle = async (fileObj: File) => {
        setFile(fileObj)
    }

    return <React.Fragment>
        <EventWrapper>
            <Title variant='h4' sx={{ fontWeight: 800, marginTop: '16px', color: '#408697' }}>Create Event</Title>
            <FormWrapper>

                <FormControl fullWidth>
                    <Stack spacing={2}>
                        {props.isPublic == true &&
                            <>
                                <FormSelectField control={control} name='public_type' label='Event Type' options={Object.values(PublicEvent).filter(item => item != 'All Event Type').map(item => {
                                    return {
                                        "value": item,
                                        "label": item
                                    }
                                })} disabled />

                            </>

                        }
                        <FormTextField control={control} name='message' label='Name:' disabled={true} required />
                        <FormTextField control={control} name='notes' label='Description:' disabled={true} />
                        {props.isPublic == true &&
                            <FormAddressField control={control} name='regions' label='Regions' />
                        }

                        <FormTextField control={control} name='address' label='Address:' disabled={true} />
                        <DateNTimePicker control={control} name='start' label='Start Date:' setValue={setValue} required />
                        <DateNTimePicker control={control} name='end' label='End Date:' setValue={setValue} required />
                        <FormTextField control={control} name='contact_email' label='Contact Email:' disabled={true} />
                        <FormTextField control={control} name='link' label='Event Link:' disabled={true} />

                        <Upload completeHandle={completeHandle} hideFileList={true} />
                    </Stack>
                    <Button
                        onClick={handleSubmit(onSubmit, (err) => {
                            console.log('erro', err)
                        })}
                        variant="outlined"
                        sx={{
                            ':hover': {
                                bgcolor: 'primary.main', // theme.palette.primary.main
                                color: '000',
                            },
                            color: 'white',
                            marginTop: '10px',
                            padding: '8px',
                        }}>Add Event</Button>
                    <Dialog open={openSuccessDialog} onClose={handleCloseSuccessDialog}>
                        <DialogTitle>{"Success"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {props.isPublic == true ? 'Your event has been submitted for review' : 'Event created successfully.'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button sx={{
                                ':hover': {
                                    bgcolor: '#408697 !important',  // Change this value to the desired opacity
                                }, padding: '0 !important', color: 'white', width: '100%'
                            }} onClick={handleCloseSuccessDialog} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </FormControl>
            </FormWrapper>




        </EventWrapper>
    </React.Fragment>






}
const FormWrapper = styled(Box)`
    padding:16px;
`
const StyleFormLabel = styled(FormLabel)`
    font-weight: 500 !important;
    color:#000 !important;
    font-size:18px !important;
    margin-right:20px !important;
    font-family: inherit !important;
    width:150px;
    line-height:100%;
`
export default App